import Deck, { PureDeck } from './Deck';

export { PureDeck }
export default Deck;
